export const kServing = 0;
export const kReturning = 1;
export const kRally = 2;
export const kKeypoint = 3;
export const kRallyCounter = 4;
export const kMissingPoint = 10;
export const kMissingGame = 20;
export const kMissingRally = 30;
export const kCoachTag = 40;

export const kServeIn = 0;
export const kServeFootfault = 1;
export const kServeAce = 2;
export const kServeWinner = 3;
export const kServeLet = 4;
export const kServeOut = 5;
export const kServeNet = 6;
export const kServeOutOffNet = 7;
export const kServeTimeViolation = 8;
export const kServeCodeViolation = 9;
export const kServeOther = 10;

export const kServeFirst = 0;
export const kServeSecond = 1;
export const kAfterServe = 2;
export const kAfterReturn = 3;

export const kReturnIn = 0;
export const kReturnInOffNet = 1;
export const kReturnVolleyed = 2;
export const kReturnWinner = 3;
export const kReturnForcingError = 4;
export const kReturnPassingShot = 5;
export const kReturnOut = 6;
export const kReturnUnforcedError = 7;
export const kReturnFirst = 8;
export const kReturnSecond = 9;
export const kReturnNetted = 10;

export const kForehand = 0;
export const kBackhand = 1;
export const kUnknownhand = 2;

export const kRallyDrive = 0;
export const kRallySlice = 1;
export const kRallyTopspin = 2;
export const kRallyVolley = 3;
export const kRallyOverhead = 4;
export const kRallyLob = 5;
export const kRallyDropshot = 6;
export const kRallyOther = 7;
export const kRallyDriveVolley = 8;
export const kRallyServeVolley = 9;
export const kRallySmash = 10;
export const kRallyApproach = 11;
export const kRallyDropVolley = 12;
export const kRallyBounceOverhead = 13;
export const kRallyVolleyPoach = 14;
export const kRallyHalfVolley = 15;
export const kRallyPassingShot = 16;
export const kRallyPowerShot = 17;
export const kRallyFlat = 18;
export const kRallyKick = 19;

export const kRallyOutcomeIn = 0;
export const kRallyOutcomeOut = 1;
export const kRallyOutcomeWinner = 2;
export const kRallyOutcomeUnforcedError = 3;
export const kRallyOutcomeForcingError = 4;
export const kRallyOutcomePassingShot = 5;
export const kRallyOutcomeNetcord = 6;
export const kRallyOutcomePutAway = 7;
export const kRallyOutcomeNetted = 8;
export const kRallyOutcomeOutOffNet = 9;
export const kRallyOutcomeNettedPassingShot = 10;
export const kRallyOutcomeOutPassingShot = 11;

export const kIsServing = 1;
export const kBreakPointAgainst = 2;
export const kBreakPoint = 3;
export const kBreakPointConverted = 4;
export const kBreakPointConceded = 5;

export const kDirectionInsideOut = 0;
export const kDirectionInsideIn = 1;
export const kDirectionCrossCourt = 2;
export const kDirectionDownTheLine = 3;
export const kDirectionCentre = 4;

export const kReachComfortable = 0;
export const kReachStretch = 1;
export const kReachBody = 2;
export const kReachNA = 3;

export const kOutcomeNoMatch = -1;
export const kOutcomeWinner = 0;
export const kOutcomeError = 1;
export const kOutcomeServeReturnIn = 2;
export const kOutcomeServeLet = 3;
export const kOutcomeUnforcedError = 4;
export const kOutcomeViolation = 5;

export const kScores00_00 = 0;
export const kScores15_00 = 1;
export const kScores30_00 = 2;
export const kScores00_15 = 3;
export const kScores15_15 = 4;
export const kScores30_15 = 5;
export const kScores00_30 = 6;
export const kScores15_30 = 7;
export const kScores30_30 = 8;
export const kScores00_40 = 9;
export const kScores15_40 = 10;
export const kScores30_40 = 11;
export const kScores40_15 = 12;
export const kScores40_30 = 13;
export const kScores40_00 = 14;
export const kScoresDeuce = 15;
export const kScoresServerAd = 16;
export const kScoresReturnerAd = 17;
export const kScoresBreakPointFor = 18;
export const kScoresBreakPoint = 19;
export const kScoresGamePoint = 20;
export const kScoresTiebreak = 21;

export const kServeFormationTraditional = 0;
export const kServeFormationEye = 1;
export const kServeFormationSqueeze = 2;
export const kServeFormationTandem = 3;
export const kServeFormationTwoBack = 4;

export const kReturnFormationTradition = 0;
export const kReturnFormationTwoBack = 1;

export const kNetPostitonHolding = 0;
export const kNetPostitonSwitch = 1;
export const kNetPostitonCoverMiddle = 2;
export const kNetPostitonLeft = 3;
export const kNetPostitonRight = 4;

export const kRallyServeFirst = 1;
export const kRallyServeSecond = 2;
export const kRallyServeAceWinner = 3;
export const kRallyServeDoubleFault = 4;
export const kRallyReturnUnforcedError = 5;
export const kRallyReturnWinner = 6;
export const kRallyKeypointUnforcedError = 7;
export const kRallyKeypointWinner = 8;
export const kRallyKeypointForcingError = 9;
export const kRallyBreakpoint = 10;
export const kRallyBreakpointConverted = 11;
export const kRallyPointWonOnFirstServe = 12;
export const kRallyPointWonOnSecondServe = 13;
export const kRallyPointWonOnReceive = 14;
export const kRallyPointWon = 15;
export const kRallyReturnForcingError = 16;
export const kRallyServeFirstIn = 17;
export const kRallyServeSecondIn = 18;
export const kRallyPointWonOnReceiveFirstServe = 19;
export const kRallyPointWonOnReceiveSecondServe = 20;
export const kRallyPointServeAndVolley = 21;
export const kRallyPointNetApproach = 22;

export const kStageFirstServeDeuce = 0;
export const kStageFirstServeAd = 1;
export const kStageSecondServeDeuce = 2;
export const kStageSecondServeAd = 3;
export const kStageFirstReturnDeuce = 4;
export const kStageFirstReturnAd = 5;
export const kStageSecondReturnDeuce = 6;
export const kStageSecondReturnAd = 7;
export const kStageRally = 8;
